import { FINANCE_REQUEST_STATUSES } from '@/services/financeService'

/** Fluxo de status para chamados C4 — Contrato comercial via RocketSearch. */
export const FINANCE_C4_CONTRACT_STATUSES = [
  'NOVO',
  'EM_ANDAMENTO',
  'AGUARDANDO_SOLICITANTE',
  'RESPONDIDO_SOLICITANTE',
  'AJUSTAR_PROPOSTA',
  'PROPOSTA_AJUSTADA',
  'CONTRATO_GERADO_PDF',
  'CONTRATO_ENVIADO',
  'CONTRATO_ASSINADO',
  'CANCELADO',
] as const

export type FinanceC4ContractStatus = (typeof FINANCE_C4_CONTRACT_STATUSES)[number]

export const FINANCE_C4_STATUS_LABELS: Record<string, string> = {
  NOVO: 'Novo',
  EM_ANDAMENTO: 'Em andamento',
  AGUARDANDO_SOLICITANTE: 'Aguardando solicitante',
  RESPONDIDO_SOLICITANTE: 'Respondido pelo solicitante',
  AJUSTAR_PROPOSTA: 'Ajustar proposta',
  PROPOSTA_AJUSTADA: 'Proposta ajustada',
  CONTRATO_GERADO_PDF: 'Contrato gerado em PDF',
  CONTRATO_ENVIADO: 'Contrato enviado',
  CONTRATO_ASSINADO: 'Contrato assinado',
  CANCELADO: 'Cancelado',
  EM_ANALISE: 'Em andamento',
  CONCLUIDO: 'Concluído',
}

export function isC4ContractRequestType(type: string): boolean {
  return type === 'C4_CONTRATO_AGRADA'
}

/** Status legados do fluxo genérico mapeados para o fluxo C4. */
export const FINANCE_C4_LEGACY_STATUS_ALIASES: Record<string, FinanceC4ContractStatus> = {
  EM_ANALISE: 'EM_ANDAMENTO',
  AGUARDANDO_APROVACAO: 'AGUARDANDO_SOLICITANTE',
  CONCLUIDO: 'CONTRATO_ASSINADO',
}

export function normalizeC4ContractStatus(status: string): string {
  return FINANCE_C4_LEGACY_STATUS_ALIASES[status] ?? status
}

/** Opções únicas do select C4 (sem duplicar labels por alias legado). */
export function buildC4StatusSelectOptions(currentStatus: string): string[] {
  const options = [...FINANCE_C4_CONTRACT_STATUSES]
  const normalized = normalizeC4ContractStatus(currentStatus)
  if (
    currentStatus &&
    !options.includes(normalized as FinanceC4ContractStatus) &&
    !FINANCE_C4_LEGACY_STATUS_ALIASES[currentStatus]
  ) {
    options.push(currentStatus as (typeof options)[number])
  }
  return options
}

export function getFinanceRequestStatusesForType(type: string): readonly string[] {
  return isC4ContractRequestType(type) ? FINANCE_C4_CONTRACT_STATUSES : FINANCE_REQUEST_STATUSES
}

export function formatFinanceRequestStatus(status: string, type?: string): string {
  if (type && isC4ContractRequestType(type)) {
    return FINANCE_C4_STATUS_LABELS[status] ?? status
  }
  return status
}
